function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Unavailable Icon");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M9.74553125,0.5 C14.9926736,0.5 19.2455312,4.75285763 19.2455312,10 C19.2455312,15.2471424 14.9926736,19.5 9.74553125,19.5 C4.49838888,19.5 0.24553125,15.2471424 0.24553125,10 C0.24553125,4.75285763 4.49838888,0.5 9.74553125,0.5 Z M9.74553125,1.5 C5.05067362,1.5 1.24553125,5.30514237 1.24553125,10 C1.24553125,14.6948576 5.05067362,18.5 9.74553125,18.5 C14.4403889,18.5 18.2455312,14.6948576 18.2455312,10 C18.2455312,5.30514237 14.4403889,1.5 9.74553125,1.5 Z M13.8998312,8.5003 C14.2818312,8.5003 14.5918312,8.59650769 14.5918312,8.71498567 L14.5918312,11.7856143 C14.5918312,11.9040923 14.2818312,12.0003 13.8998312,12.0003 L5.59083125,12.0003 C5.20883125,12.0003 4.89883125,11.9040923 4.89883125,11.7856143 L4.89883125,8.71498567 C4.89883125,8.59650769 5.20883125,8.5003 5.59083125,8.5003 L13.8998312,8.5003 Z",
  id: "unavailable-path-1"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "unavailable-Icon/Global/Unavailable",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "unavailable-Swatches/Midnight",
  transform: "translate(2.754469, 1.499700)"
}, /*#__PURE__*/React.createElement("use", {
  id: "unavailable-Mask",
  fill: "currentcolor",
  fillRule: "nonzero",
  xlinkHref: "#unavailable-path-1"
})));

var SvgUnavailable = function SvgUnavailable(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUnavailable, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/unavailable.b8481555.svg";
export { ForwardRef as ReactComponent };